import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const AGE_CATEGORIES_REQUEST = 'FETCH_AGE_CATEGORIES_REQUEST';
export const AGE_CATEGORIES_FAILURE = 'FETCH_AGE_CATEGORIES_FAILURE';
export const AGE_CATEGORIES_SUCCESS = 'FETCH_AGE_CATEGORIES_SUCCESS';

export const fetchAgeCategories = () => {
    return function(dispatch) {
        dispatch(fetchRequest());
        return axios(apiRequestOptions(apiPath.AGE_CATEGORIES.LIST))
            .then(transformHttpResponse)
            .then(response => dispatch(fetchSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(fetchFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const fetchRequest = () => ({ type: AGE_CATEGORIES_REQUEST })
const fetchFailure = error => ({ type: AGE_CATEGORIES_FAILURE, error})
const fetchSuccess = data => ({type: AGE_CATEGORIES_SUCCESS, data})
